import { type Role } from "../types/user";

export const setTokens = ({
  access_token,
  refresh_token,
}: {
  access_token: string;
  refresh_token: string;
}) => {
  sessionStorage.setItem("accessToken", access_token);
  localStorage.setItem("refreshToken", refresh_token);
};

export const resetTokens = () => {
  sessionStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
};

export const getAccessToken = () => sessionStorage.getItem("accessToken");

export const isTokenValid = (role: Role) => {
  const accessToken = getAccessToken();
  if (!accessToken) return false;

  let payload;
  try {
    payload = JSON.parse(atob(accessToken.split(".")[1]));
  } catch {
    return false;
  }

  if (payload.role !== role) return false;

  if (payload !== null && Date.now() < payload.exp * 1000) {
    return true;
  }
  return false;
};
